export default __webpack_public_path__ + "static/media/example-cover.44a61f01.png";